import { createPortal } from "react-dom";

export function getQueryStringValue(key: string) {
    return decodeURIComponent(
        window.location.search.replace(
            new RegExp(
                '^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'),
            '$1'));
}



export type QueryObject = { [key: string]: string | number };

function buildObjectFromQuerystring(qs?: string) {
    const queryString = qs || window.location.search.replace(/^\?+/g, '');
    let queryObj: QueryObject = {};
    for (const kv of queryString.split('&')) {
        let [key, value] = kv.split('=');
        key = key ? decodeURIComponent(key.trim()) : '';

        if (!key) {
            continue;
        }

        value = value ? decodeURIComponent(value) : '';
        if (!value) {
            continue;
        }

        queryObj[key] = value;
    }
    return queryObj;
}

function buildQuerystringFromObject(obj: QueryObject) {
    const keys = Object.keys(obj).filter(key => !!obj[key]);
    return '?' + keys
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');
}

function buildQueryString(queryKey: string, queryValue: string | number) {
    const obj = buildObjectFromQuerystring();
    obj[queryKey] = queryValue;
    return buildQuerystringFromObject(obj);
}
type queryParams = { value: number | string, key: string };
export function setQuerystring({ key, value }: queryParams) {
    window.history.replaceState('', '', buildQueryString(key, value));
}

export function setQuerystrings(objects: queryParams[]) {
    for (const obj of objects) {
        setQuerystring(obj);
    }
}

type PortalType = {
    children: React.ReactNode;
    container: string;
};

export const Portal = ({ children, container }: PortalType) => createPortal(
    children,
    (document.querySelector(container) as Element)
);